<template>
<div>
  <w-sliding-popup ref="slidingPopup" :title="popupParams.policyDescr" top="50px" width="700px" @close="close">
    <div slot="content">
      <div class="title-bar title-h4">{{ popupParams.policyDescr }} 준수/미준수</div>
      <el-table-wrapper class="mr-b25" :data="deviceCurrentComplianceData" :columns="tableColumns.objCurrentColumns" :column-default="columnDefault" :show-custom-header="false" :pagination="false" height="300px">
        <template slot-scope="scope" slot="slot">
              <span v-if="scope.column.label === '상태'">{{ setComplianceStatus(scope.row) }}</span>
              <span v-else-if="scope.column.property === 'countCR' || scope.column.property === 'countMJ' || scope.column.property === 'countMN' || scope.column.property === 'countNM'">
                <i v-if="scope.column.property === 'countCR'" class="icon-critical"></i>
                <i v-else-if="scope.column.property === 'countMJ'" class="icon-major"></i>
                <i v-else-if="scope.column.property === 'countMN'" class="icon-minior"></i>
                <i v-else-if="scope.column.property === 'countNM'" class="icon-info"></i>
                &nbsp;{{ scope.row[scope.column.property] }}
              </span>
            </template>
      </el-table-wrapper>
      <div class="title-bar title-h4">Rule별 준수현황</div>
      <el-scrollbar class="bar-visible">
        <div style="height: 400px">
          <el-collapse class="fit-content" accordion @change="onCollapseChange">
            <el-collapse-item v-for="data in ruleCurrentComplianceData" :key="data.ruleId" :name="data.ruleId">
              <template slot="title">
                <span class="mr-r4">{{ `[${data.ruleId}] ${data.ruleName}` }}</span>
                <i v-if="data.severityId === 'CR'" class="icon-critical"></i>
                <i v-else-if="data.severityId === 'MJ'" class="icon-major"></i>
                <i v-else-if="data.severityId === 'MN'" class="icon-minior"></i>
                <i v-else-if="data.severityId === 'NM'" class="icon-info"></i>
                <em>&nbsp;{{ data.severityName }}</em>
              </template>
              <el-table-wrapper :data="deviceRuleComplianceData" :columns="tableColumns.ruleCurrentColumns" :column-default="columnDefault" :show-custom-header="false" :pagination="false" height="200px">
                <template slot-scope="scope" slot="slot">
                  <i v-if="scope.column.property === 'severityId' && scope.row.severityId === 'CR'" class="icon-critical"></i>
                  <i v-else-if="scope.column.property === 'severityId' && scope.row.severityId === 'MJ'" class="icon-major"></i>
                  <i v-else-if="scope.column.property === 'severityId' && scope.row.severityId === 'MN'" class="icon-minior"></i>
                  <i v-else-if="scope.column.property === 'severityId' && scope.row.severityId === 'NM'" class="icon-info"></i>
                  <span v-else-if="scope.column.label === '스크립트 실행'">
                    <span v-if="isNil(scope.row.templateName)">{{ EMPTY_TEXT }}</span>
                    <i v-else class="fas fa-play-circle text-14 c-pointer" @click="executeScript(scope.row)"/>
                  </span>
                  <!-- <span v-else-if="scope.column.label === '스크립트 실행'" class="link" @click="executeScript(scope.row)">{{ scope.row.templateName ? '[실행]' : '-' }}</span> -->
                </template>
              </el-table-wrapper>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-scrollbar>
    </div>
  </w-sliding-popup>
  <w-execute-rule-script-popup :popup-params="scriptPopupParams" ref="executeRuleScriptPopup" @open="close" @close="open"></w-execute-rule-script-popup>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WExecuteRuleScriptPopup from './ExecuteRuleScriptPopup';

export default {
  name: 'WPolicyCurrentCompliancePopup',
  components: {
    WExecuteRuleScriptPopup,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      popupVisible: false,
      deviceCurrentComplianceData: [],
      ruleCurrentComplianceData: [],
      deviceRuleComplianceData: [],
      scriptPopupParams: {},
      columnDefault,
      EMPTY_TEXT,
      tableColumns: {
        objCurrentColumns: [
          {
            label: '상태',
            width: 80,
            sortable: true,
            searchable: false,
            headerAlign: 'center',
            scopedSlot: 'slot',
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'objName',
            label: '장비명',
            headerAlign: 'center',
            sortable: true,
            searchable: false,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            label: '룰 준수 여부',
            headerAlign: 'center',
            childColumns: [
              {
                prop: 'countCR',
                label: '위험',
                width: 70,
                sortable: true,
                searchable: false,
                scopedSlot: 'slot',
                formatter: this.getTableValueAfterCheckEmpty,
              },
              {
                prop: 'countMJ',
                label: '경고',
                width: 70,
                sortable: true,
                searchable: false,
                scopedSlot: 'slot',
                formatter: this.getTableValueAfterCheckEmpty,
              },
              {
                prop: 'countMN',
                label: '주의',
                width: 70,
                sortable: true,
                searchable: false,
                scopedSlot: 'slot',
                formatter: this.getTableValueAfterCheckEmpty,
              },
              {
                prop: 'countNM',
                label: '준수',
                width: 70,
                sortable: true,
                searchable: false,
                scopedSlot: 'slot',
                formatter: this.getTableValueAfterCheckEmpty,
              },
            ],
          },
          {
            prop: 'checkDatetime',
            label: '마지막 확인 시각',
            headerAlign: 'center',
            width: 130,
            sortable: true,
            searchable: false,
            formatter: this.convertDatetime,
          },
        ],
        ruleCurrentColumns: [
          {
            prop: 'objName',
            label: '장비명',
            width: 200,
            sortable: true,
            searchable: false,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'severityId',
            label: '준수 여부',
            width: 80,
            align: 'center',
            sortable: true,
            searchable: false,
            scopedSlot: 'slot',
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'templateName',
            label: '권장스크립트',
            sortable: true,
            searchable: false,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            label: '스크립트 실행',
            width: 100,
            align: 'center',
            sortable: true,
            searchable: false,
            scopedSlot: 'slot',
          },
        ],
      },
    };
  },
  methods: {
    isNil,
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 정책의 장비별, 룰별 준수/미준수 데이터 로드
     * @author jeee12
     */
    loadData() {
      this.$nextTick(() => {
        netdeviceInfoAPI
          .getCurrentPolicyComplianceByDevice({
            policyId: this.popupParams.policyId,
            managegroupIds: this.popupParams.managegroupIds,
          })
          .then((response) => {
            if (response.data.success) {
              this.deviceCurrentComplianceData = response.data.data;
            }
          });

        netdeviceInfoAPI
          .getCurrentPolicyComplianceByRule({
            policyId: this.popupParams.policyId,
            managegroupIds: this.popupParams.managegroupIds,
          })
          .then((response) => {
            if (response.data.success) {
              this.ruleCurrentComplianceData = response.data.data;
            }
          });
      });
    },
    /**
     * 장비별 준수/미준수 현황 테이블 상태컬럼 표현 설정
     * @author jeee12
     * @param  {Object} currentRow 설정할 현재 row
     */
    setComplianceStatus(currentRow) {
      if (currentRow.countCR + currentRow.countMJ + currentRow.countMN > 0) {
        return '미준수';
      } else if (currentRow.countNM > 0) {
        return '준수';
      }
      return '-';
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 테이블 날짜 포맷 설정
     * @author jeee12
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * collapse 아이템 change
     * @author jeee12
     * @param  {String} activeRule 현재 활성화된 collapse item name
     */
    onCollapseChange(activeRule) {
      if (activeRule) {
        netdeviceInfoAPI
          .getCurrentRuleComplianceByDevice({
            policyId: this.popupParams.policyId,
            ruleId: activeRule,
            managegroupIds: this.popupParams.managegroupIds,
          })
          .then((response) => {
            if (response.data.success) {
              this.deviceRuleComplianceData = response.data.data;
            }
          });
      }
    },
    /**
     * 스크립트 실행 click
     * @author jeee12
     * @param  {[type]} row 해당 row
     */
    executeScript(row) {
      if (row.templateName) {
        this.scriptPopupParams = row;
        this.$refs.executeRuleScriptPopup.open();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/group/netdevice/components/popup/PolicyCurrentCompliancePopup.vue